import { render, staticRenderFns } from "./UserWealthRecordDialog.vue?vue&type=template&id=20e67376&scoped=true&lang=pug&"
import script from "./UserWealthRecordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserWealthRecordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserWealthRecordDialog.vue?vue&type=style&index=0&id=20e67376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e67376",
  null
  
)

export default component.exports